export default __webpack_public_path__ + "static/helix-bq-3-13e3ba2959238a0168de92d0c33cf60b.jpg";